
export enum RequestPermissionNotificationStatus {
    
    NoAction = 0,
    Accepted = 1,
    Rejected = 2
}